import { render, staticRenderFns } from "./popUserSearch.vue?vue&type=template&id=2253f837&scoped=true&"
import script from "./popUserSearch.vue?vue&type=script&lang=js&"
export * from "./popUserSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2253f837",
  null
  
)

export default component.exports